module.exports = __webpack_public_path__ + "images/powerups/calendar/screenshots/2015-3-23-screenshot1.e204a5ed5a8dc113760b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/powerups/calendar/screenshots/2015-3-23-screenshot1.png
// module id = ft2W
// module chunks = 0